// src/theme/tokens/palette.js
// Faz 1 · Genisletilmis renk paletleri.
// Mevcut colors.js dokunulmaz. Bu dosya, ek olarak dahil edilecek
// yeni paletleri (warm neutrals, exam-spesifik tonlar, klinik aksanlar) saglar.
// Hicbir mevcut token uzerine yazmaz; sadece yeni anahtarlar ekler.
// extendTheme merge stratejisi ile colors objesine eklenir.

const hexToRgba = (hex, alpha) => {
  if (!hex || typeof hex !== 'string' || hex.length < 4) return `rgba(0,0,0,${alpha})`;
  try {
    const shorthand = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthand, (_, r, g, b) => r + r + g + g + b + b);
    const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!m) return `rgba(0,0,0,${alpha})`;
    return `rgba(${parseInt(m[1], 16)}, ${parseInt(m[2], 16)}, ${parseInt(m[3], 16)}, ${alpha})`;
  } catch {
    return `rgba(0,0,0,${alpha})`;
  }
};

// Brand alpha rampa · mevcut ad-hoc alpha'lari tek noktada toplar.
// Bu degerler colors.brand altina merge edilecek.
const brandAlphaRamp = (base) => ({
  '500_alpha_5': hexToRgba(base[500], 0.05),
  '500_alpha_8': hexToRgba(base[500], 0.08),
  '500_alpha_12': hexToRgba(base[500], 0.12),
  '500_alpha_15': hexToRgba(base[500], 0.15),
  '500_alpha_20': hexToRgba(base[500], 0.2),
  '500_alpha_30': hexToRgba(base[500], 0.3),
  '500_alpha_40': hexToRgba(base[500], 0.4),
  '500_alpha_50': hexToRgba(base[500], 0.5),
  '500_alpha_60': hexToRgba(base[500], 0.6),
  '300_alpha_10': hexToRgba(base[300], 0.1),
  '300_alpha_20': hexToRgba(base[300], 0.2),
  '300_alpha_40': hexToRgba(base[300], 0.4),
  '700_alpha_20': hexToRgba(base[700], 0.2),
  '700_alpha_40': hexToRgba(base[700], 0.4),
});

// Brand ek step'leri · mevcut 50-900 yaninda 25 ve 950.
const brandExtensions = {
  25: '#F4FAFF',   // Ultra acik, soft surface backdrop icin
  950: '#0B3D66',  // Ultra koyu, premium dark surface icin
};

// Amber · basari/streak/odul/premium aksani.
// Mevcut yellow korunur; amber daha sicak, daha az saridir.
const amber = {
  25: '#FFFBF0',
  50: '#FFF7E0',
  100: '#FEEAB1',
  200: '#FCD97A',
  300: '#FAC74A',
  400: '#F5B324',
  500: '#E89C09',  // Ana amber
  600: '#C27D03',
  700: '#996102',
  800: '#704701',
  900: '#4D3000',
  950: '#2E1C00',
};

// Teal · klinik/medikal aksani, success+info arasi.
const teal = {
  25: '#F0FBFA',
  50: '#DEF7F4',
  100: '#B3EDE4',
  200: '#80DFD0',
  300: '#4ECFB9',
  400: '#2BBCA1',
  500: '#149E84',  // Ana teal
  600: '#0F8169',
  700: '#0B6452',
  800: '#08493B',
  900: '#053027',
  950: '#021E18',
};

// Emerald · exam.correct icin yesilden daha zarif bir varyant.
const emerald = {
  25: '#F1FBF6',
  50: '#DCF7E8',
  100: '#B0EFCB',
  200: '#7CE3A8',
  300: '#4DD085',
  400: '#27B665',
  500: '#0E9650',  // Ana emerald
  600: '#0A7B40',
  700: '#085F32',
  800: '#054524',
  900: '#032E18',
  950: '#021C0F',
};

// Rose · exam.incorrect icin red'den daha az agresif, modern bir kirmizi.
const rose = {
  25: '#FFF5F7',
  50: '#FFE4EA',
  100: '#FEC0CD',
  200: '#FA94AA',
  300: '#F46583',
  400: '#E83A60',
  500: '#CC1F46',  // Ana rose
  600: '#A4153A',
  700: '#7E0F2C',
  800: '#5A0A1F',
  900: '#3D0615',
  950: '#26030C',
};

// Slate · warm neutral, gray'in alternatifi (yeni componentler icin onerilen).
// Mevcut gray geriye uyumluluk icin korunur.
const slate = {
  25: '#FAFBFC',
  50: '#F4F6F8',
  100: '#E6EAEF',
  200: '#CFD6DE',
  300: '#A8B3BF',
  400: '#7B8794',
  500: '#5B6671',
  600: '#434C56',
  700: '#2F373F',
  750: '#262D34',
  800: '#1C2229',
  850: '#161B21',
  900: '#0F1419',
  950: '#080B0E',
};

// Indigo · alternatif accent, "premium AI" hissi icin.
const indigo = {
  25: '#F4F4FE',
  50: '#E8E9FD',
  100: '#C7CAFB',
  200: '#9CA1F7',
  300: '#7077F1',
  400: '#4C53E8',
  500: '#2F35D1',  // Ana indigo
  600: '#2429AB',
  700: '#1B1F87',
  800: '#131761',
  900: '#0C0E40',
  950: '#070827',
};

// Hex'lerin alpha varyantlari · gerektiginde semantic token'larda kullanilacak.
const withAlphas = (palette) => ({
  ...palette,
  '500_alpha_8': hexToRgba(palette[500], 0.08),
  '500_alpha_15': hexToRgba(palette[500], 0.15),
  '500_alpha_25': hexToRgba(palette[500], 0.25),
  '500_alpha_40': hexToRgba(palette[500], 0.4),
  '300_alpha_15': hexToRgba(palette[300], 0.15),
  '300_alpha_30': hexToRgba(palette[300], 0.3),
});

// Disa aktarim · colors.js ile merge edilecek sekilde duzenlenir.
// Sadece YENI anahtarlar; mevcut palet uzerine yazmaz.
const paletteExtensions = {
  brand: {
    ...brandExtensions,
    ...brandAlphaRamp({ 300: '#73C5FF', 500: '#4DA8FF', 700: '#2D86CC' }),
  },
  amber: withAlphas(amber),
  teal: withAlphas(teal),
  emerald: withAlphas(emerald),
  rose: withAlphas(rose),
  slate: withAlphas(slate),
  indigo: withAlphas(indigo),
};

export default paletteExtensions;
export { amber, teal, emerald, rose, slate, indigo, brandExtensions, brandAlphaRamp, hexToRgba };
